import React from 'react';
import { ErrorBoundary, PaymentErrorFallback, QuoteFormErrorFallback } from '@/components/ui/ErrorBoundary';

// Test/Debug route imports - remaining after cleanup
const HSNIntegrationTest = React.lazy(() => import('@/components/test/HSNIntegrationTest').then((m) => ({ default: m.HSNIntegrationTest })));
const AdminStatusDebug = React.lazy(() => import('@/pages/debug/AdminStatusDebug'));
const WarehouseDebug = React.lazy(() => import('@/components/debug/WarehouseDebug'));
const ConsolidationDebug = React.lazy(() => import('@/debug/ConsolidationDebug'));

// Public test routes (no authentication required)
export const publicTestRoutes = [
  {
    path: 'test/hsn-integration',
    element: <HSNIntegrationTest />,
  },
];

// Protected test routes (authentication required)
export const protectedTestRoutes = [
  {
    path: 'debug/admin-status',
    element: <AdminStatusDebug />,
  },
  {
    path: 'debug/warehouse',
    element: <WarehouseDebug />,
  },
  {
    path: 'debug/consolidation',
    element: <ConsolidationDebug />,
  },
];